import { createI18n } from "vue-i18n";
import en from "./lang/en.json";
import ar from "./lang/ar.json";

const messages = {
    en,
    ar,
}

const i18n = createI18n({
    locale: localStorage.getItem("lang") || "ar",
    messages
})

export default i18n;